import { render, staticRenderFns } from "./wy-header-menu-languages.vue?vue&type=template&id=ba9e6f3c&"
import script from "./wy-header-menu-languages.vue?vue&type=script&lang=js&"
export * from "./wy-header-menu-languages.vue?vue&type=script&lang=js&"
import style0 from "./wy-header-menu-languages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports